import {TIMEOUTS} from 'lib/Commons';

const REQUEST_TIMEOUT = 'Request Timeout.';
const ABORT_CONTROLLER_ERROR_NAME = 'AbortError';
const GET_OPTIONS = {
    method: 'GET',
};
const timeoutHandler = (timeout) => {
    const controller = new AbortController();
    const fetchTimeout = setTimeout(() => controller.abort(), timeout);
    return {
        signal: controller.signal,
        timeout: fetchTimeout,
    };
};
const buildRequest = (url, options) => {
    const { signal, timeout } = timeoutHandler(TIMEOUTS.LONG);
    return fetch(url, { signal, ...options })
        .then((responseObject) => {
            clearTimeout(timeout);
            return responseObject;
        })
        .catch((error) => {
            const _error = error.name === ABORT_CONTROLLER_ERROR_NAME ? REQUEST_TIMEOUT : error;
            throw new Error(_error);
        });
};
const getJson = (url, options = {}) => {
    return buildRequest(url, { ...GET_OPTIONS, ...options })
        .then(result => result.json());
};
const getText = (url, options = {}) => {
    return buildRequest(url, { ...GET_OPTIONS, ...options })
        .then(result => result.text());
};

const FetchAPI = {
    getJson,
    getText
};

export default FetchAPI;
